

































































































































































import {  ImportaEstoquesUseCase } from '@/usecases';
import { Component, Prop, Ref, Vue } from 'vue-property-decorator' ;
import { VueCsvImport } from 'vue-csv-import';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { EstoqueCsvForm, Loja } from '@/models';
import { ExportAllItensEstoqueUseCase } from '@/usecases/loja/adapter/ExportAllItensEstoqueUseCase';


@Component({
	components: {
		VueCsvImport,
	},
})
export default class DialogoDeCsvTabelaDeEstoque extends Vue {
	@Ref() csvComponent!: VueCsvImport
	@Prop() loja!: Loja
	mostra = false
	tab: null | number = null
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
		{ action:'Exportar', icon: 'mdi-file-download' },
	]
	exportAllItensEstoqueUseCase = new ExportAllItensEstoqueUseCase()
	importaEstoquesUseCase = new ImportaEstoquesUseCase()
	importando = false
	exportando = false
	estadoDaSelecao = "Nenhum arquivo selecionado"  
	csv: EstoqueCsvForm[] | null = null

	camposCsvComEstoqueMinimo = {
		sku:'skuDoProduto', 
		qtdEstoque: 'qtdeEstoque',
		qtdEmpenhada: 'qtdeEmpenhada',
		estoqueMinimo: 'estoqueMinimo',
	}

	camposCsvSemEstoqueMinimo = {
		sku:'skuDoProduto', 
		qtdEstoque: 'qtdeEstoque',
		qtdEmpenhada: 'qtdeEmpenhada',
	}
	
		
	arquivo = 'File'

	tabelaNome: string | null = null
	tabelaId: string | null = null
	selecionado: boolean | null = null
	inputFile: HTMLInputElement | null = null

	async mostrar(tabelaId?: string, tabelaNomeRecebido?: string){
		this.tabelaId = tabelaId ? tabelaId : null
		this.tabelaNome = tabelaNomeRecebido ? tabelaNomeRecebido : null
		this.mostra = true
	}
	cancelar() {
		this.importando = false
		this.csv = null 
		this.mostra = false
		this.csvComponent.sample =  null
		this.csvComponent.fileSelected = false
		this.csvComponent.map = []
		if(this.inputFile!= null)
			this.inputFile.value = ''
	}
	async concluirImportacao(){
		if(!this.csv) return
		if (!this.tabelaId) return
		try {
			await this.importaEstoquesUseCase.execute(this.tabelaId, this.csv)

			AlertModule.setSuccess('Itens em processamento')
			this.$emit('concluiuImportacao')
		} catch (e) {
			AlertModule.setError(e)
		} finally { 
			this.importando = false
			this.csv = null 
			this.mostra = false
			this.csvComponent.sample =  null
			this.csvComponent.fileSelected = false
			this.csvComponent.map = []
			if(this.inputFile!= null)
				this.inputFile.value = ''
		}
	}
	async exportarCsv() {
		if(!this.tabelaId) return
		try {
			AlertModule.setSuccess('O arquivo está sendo gerado. O processo pode levar alguns minutos.')
			const response: any = await this.exportAllItensEstoqueUseCase.exportEstoque(this.tabelaId)
			const url = window.URL.createObjectURL(new Blob([response]));
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', `Estoque_${this.tabelaNome}.csv`)
			document.body.appendChild(link)
			link.click()
		} catch (e) {
			AlertModule.setError(e)
		}
	}
	clickCsv() {
		this.inputFile = document.querySelector('.form-control-file')
		if(this.inputFile != null)
			this.inputFile.click();
		
	}

	get arquivoSelecionado() {
		if(this.csvComponent.fileSelected){
			return "Arquivo selecionado, favor definir colunas"
		}
		return "Nenhum arquivo selecionado"
	}

}
